import { createContext, useContext, useState, useCallback } from "react";

const BookingDialogContext = createContext(null);

export function BookingDialogProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [defaultTier, setDefaultTier] = useState(null);

  const openDialog = useCallback((tier = null) => {
    setDefaultTier(tier);
    setOpen(true);
  }, []);

  const closeDialog = useCallback(() => setOpen(false), []);

  return (
    <BookingDialogContext.Provider
      value={{ open, openDialog, closeDialog, setOpen, defaultTier }}
    >
      {children}
    </BookingDialogContext.Provider>
  );
}

export function useBookingDialog() {
  const ctx = useContext(BookingDialogContext);
  if (!ctx) {
    throw new Error("useBookingDialog must be used within BookingDialogProvider");
  }
  return ctx;
}
